import React from 'react';
import PropTypes from 'prop-types';

const SIZE_CLASSES = {
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-8 h-8 border-4',
  xl: 'w-12 h-12 border-4',
  '2xl': 'w-16 h-16 border-4',
};

export default function Loader({ size = 'lg', label = 'Loading...', className = '' }) {
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;

  return (
    <div
      role="status"
      className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center ${className}`}
    >
      <span
        className={`inline-block ${sizeClass} rounded-full animate-spin border-primary border-t-transparent`}
      >
        <span className="sr-only">{label}</span>
      </span>
    </div>
  );
}

Loader.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', '2xl']),
  label: PropTypes.string,
  className: PropTypes.string,
};
